import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaRecordFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "9", cy: "9", r: "8", fill: "currentColor" })));
};
//# sourceMappingURL=IconMediaRecordFill18.js.map